export const ADMIN = 'ADMIN';
export const USER = 'USER';
export const GUEST = 'GUEST';
